export default "__VITE_ASSET__e179b434__"